import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/simp_in/step3';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { TypeOuiNonReservationMarche } from '../models/TypeOuiNonReservationMarche';
import { Oui_TypeOuiNonReservationMarche } from '../models/Oui_TypeOuiNonReservationMarche';
@Component({
	selector: 'app-type-oui-non-reservation-marche',
	templateUrl: './type-oui-non-reservation-marche.component.html'
})
export class TypeOuiNonReservationMarcheComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeOuiNonReservationMarche';
	@Input() parentForm: FormGroup;

	@Input() disabled: boolean;
	@Input() reservationMarche: TypeOuiNonReservationMarche;

	public step3 = new Step3();

	constructor() {}

	public ngOnInit() {
		if ((this.reservationMarche.non === RadioCheckBoxEnum.emptyValue || this.reservationMarche.non === 'Non') && this.reservationMarche.oui == null) {
			this.reservationMarche.non = RadioCheckBoxEnum.nonValue;
		}
		else if (this.reservationMarche.oui) {
			this.reservationMarche.non = RadioCheckBoxEnum.ouiValue;
		}
		else {
			this.reservationMarche.non = RadioCheckBoxEnum.emptyValue;
		}
	}

	isReservationMarcheOui() {
		if (this.parentForm.controls[this.getUid() + '_SepAtt_non'].value === 'Oui') {
			if (!this.reservationMarche.oui) {
				this.reservationMarche.oui = new Oui_TypeOuiNonReservationMarche();
			}
      		return true;
    	}
    
    	this.reservationMarche.oui = null;
    	return false;
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
